import React, { useRef, useEffect } from 'react';
import { motion } from 'framer-motion';

import LogoutIcon from '@mui/icons-material/Logout';
import HelpOutline from '@mui/icons-material/HelpOutline';
import AddToHome from './AddToHome';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';


import {Link} from 'react-router-dom';
import { useStateContext } from '../contexts/ContextProvider';

const ProfileDropdown = ({ onClose, profileRef, dropdownRef  }) => { 



  const { setIsLogged } = useStateContext();

  const handleClickOutside = (event) => {
    if (profileRef.current && profileRef.current.contains(event.target)) return; // <-- Added this line
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        onClose();
    }
};

  const handleLogout = () => {
    localStorage.removeItem('jwt'); // Remove the JWT token from localStorage
    setIsLogged(false);             // Update the application state
  };



  useEffect(() => { // Step 2: useEffect
    document.addEventListener('mousedown', handleClickOutside);
    return () => { // Step 3: Clean up
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);



  const ContainerStyles = "absolute top-[4.9em] right-0 bg-yellow1 max-w-sm profiledropdown divide-y divide-gray-100 shadow";
  const ItemStyles = "flex px-6 py-2.5  font-semibold text-gray-900  space-x-3 items-center"; // Added classes


  return (
    <motion.div className={ContainerStyles} ref={dropdownRef}
    initial={{ opacity: 0, scale: 0.95 }}
    animate={{ opacity: 1, scale: 1 }}
    exit={{ opacity: 0, scale: 0.95 }}
    transition={{ duration: 0.1 }}
  >
      <AddToHome className={ItemStyles}/>
      <Link  to="/Help" className={ItemStyles}>
         <HelpOutline/>
         <span>Help</span>
      </Link>
      <a href="https://splitdiscount.com"  className={ItemStyles} target="_blank" rel="noopener noreferrer">
        <ShoppingCartIcon/>
         <span>Shop</span>
      </a>
      <a href="#" className={ItemStyles} onClick={handleLogout}>
        <LogoutIcon/>
         <span>Logout</span>
      </a>
    </motion.div>
  )
}

export default ProfileDropdown